import { AxiosResponse } from 'axios'
import magentoAxios from '../../api/global/magentoAxios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'

interface ForgotPasswordResponse {
  data: {
    requestPasswordResetEmail: boolean | null
  }
  errors?: [{ message: string }]
}

export const forgotPasswordMutation = gql`
  mutation($email: String!) {
    requestPasswordResetEmail(email: $email)
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const forgotPassword = async (email: string, recaptchaToken?: string): Promise<void> => {
  const { data }: AxiosResponse<ForgotPasswordResponse> = await magentoAxios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    recaptchaToken: recaptchaToken,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName()
    },
    data: {
      query: forgotPasswordMutation,
      variables: {
        email,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }
}
